// extracted by mini-css-extract-plugin
module.exports = {"search__title":"Input_search__title__2IuBE","search__field":"Input_search__field__1vTzK","search__icon":"Input_search__icon__31YRO"};